import { WidgetFrame } from "@/components/layout/WidgetFrame";
import { WidgetWithQueryParameters } from "@/components/layout/WidgetFrame/widget.types";
import {
    type ChartData,
    chartColor,
    createTimeXAxis,
    createLinearYAxis,
    createLineChartDataset,
    createLineChartConfiguration,
    createTooltipConfiguration,
} from "@/components/ui/Chart";
import { useDataSource } from "@/features/data-source/useDataSource";
import { routes } from "@/routes";
import { generatePath } from "@/routes/routes.utils";

type Props = WidgetWithQueryParameters<"dateTo" | "dateFrom">;

type DataSourceRow = {
    ChartDate: string;
    ChartValue: number;
    ChartLabel: string;
};

// Source: FMSDashboard_HorizonUsage_FarmsRegisteredHorizonKPI_VegaLiteWidget.json
// id: 25660b3c-6c96-4ded-b6eb-a9aa6f3b11ff
const FarmsRegisteredHorizonWidget = (props: Props) => {
    const { queryParameters } = props;
    const title = "Farms registered Horizon";

    const dataDataSource = useDataSource<DataSourceRow[]>("horizon-usage/farms-registered-horizon", {
        ...queryParameters,
    });
    const mainDataSources = [dataDataSource];

    const data = dataDataSource?.data ?? [];

    const chartConfiguration = createLineChartConfiguration({
        scales: {
            x: createTimeXAxis(),
            y: createLinearYAxis(),
        },
        plugins: {
            tooltip: createTooltipConfiguration<DataSourceRow>({
                getLabel: ({ raw }) => `Registered farms/all farms: ${raw.ChartLabel}`,
            }),
        },
    });

    const chartData: ChartData = {
        labels: data.map(({ ChartDate }) => ChartDate),
        datasets: [
            createLineChartDataset({
                label: "Farms registered Horizon",
                data: data.map(({ ChartDate, ChartValue, ChartLabel }) => ({
                    x: ChartDate,
                    y: ChartValue,
                    ChartLabel,
                })),
                color: chartColor.darkTeal,
            }),
        ],
    };

    return (
        <>
            <WidgetFrame.Title title={title} icon={"lely-icon-diagram"} link={generatePath(routes.horizonInsights)}>
                <WidgetFrame.Title.Information lastImportType={"middleware"} pageId={1199243296} />
            </WidgetFrame.Title>
            <WidgetFrame.Chart configuration={chartConfiguration} data={chartData} dependencies={mainDataSources} />
        </>
    );
};

export { FarmsRegisteredHorizonWidget };
